<!-- ----------------------------------------------- -->
<template>
  <v-card id="tm-obs-dialog" class="com-mb-dialog normal tm-mb-no-shadow">
    <v-col class="obs-header">
      <v-row class="obs-kind">
        <span v-if="reqParam.itmkndCd === 1" class="obs-title"
          >雨量観測所情報</span
        >
        <span v-if="reqParam.itmkndCd === 2" class="obs-title"
          >流域平均観測所情報</span
        >
        <span v-if="reqParam.itmkndCd === 3" class="obs-title"
          >積雪観測所情報</span
        >
        <span v-if="reqParam.itmkndCd === 4" class="obs-title"
          >水位観測所情報</span
        >
        <span v-if="reqParam.itmkndCd === 6" class="obs-title"
          >水質観測所情報</span
        >
        <span v-if="reqParam.itmkndCd === 7" class="obs-title"
          >ダム観測所情報</span
        >
        <span v-if="reqParam.itmkndCd === 12" class="obs-title"
          >海岸観測所情報</span
        >
        <span v-if="reqParam.itmkndCd === 20" class="obs-title"
          >レーダ流域観測所情報</span
        >
        <span v-if="reqParam.itmkndCd === 100" class="obs-title"
          >河川カメラ情報</span
        >
        <span v-if="reqParam.itmkndCd === 200" class="obs-title"
          >簡易カメラ情報</span
        >
        <span v-if="reqParam.itmkndCd === 300" class="obs-title"
          >{{ this.$store.state.app.config.replaceNameConfig.swstg }}情報</span
        >
        <span class="pl-2" v-if="reqParam.itmkndCd === 4">
          <v-tooltip bottom max-width="350px">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="white"
                >help_outline</v-icon
              >
            </template>
            <span>
              <span>
                {{ legendStr.tmStg.tmStgMsg1 }}
                <br />
                {{ legendStr.tmStg.tmStgMsg2 }}
                <br />
              </span>
              <span class="text-flood-occurrence mb-legend-stg-span mb-1">
                {{ legendStr.tmStg.occurrence }}
              </span>
              <br />
              <span class="text-flood-danger mb-legend-stg-span mb-1">
                {{ legendStr.tmStg.danger }}</span
              >
              <br />
              <span class="text-flood-refuge mb-legend-stg-span mb-1">
                {{ legendStr.tmStg.refuge }}
              </span>
              <br />
              <span class="text-flood-warn mb-legend-stg-span mb-1">
                {{ legendStr.tmStg.warn }}
              </span>
            </span>
          </v-tooltip>
        </span>
        <span class="pl-2" v-else-if="reqParam.itmkndCd === 300">
          <v-tooltip bottom max-width="350px">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" color="white"
                >help_outline</v-icon
              >
            </template>
            <span>
              <span>
                {{ legendStr.swStg.swStgMsg1 }}
                <br />
                {{ legendStr.swStg.swStgMsg2 }}
                <br />
              </span>
              <v-row no-gutters class="pt-1 pb-1">
                <v-col>
                  <v-row no-gutters>
                    <div class="text-swstg-flood mb-legend-swstg-item">
                      {{ legendStr.swStg.flood1 }}
                    </div>
                  </v-row>
                  <v-row no-gutters>
                    <div class="text-swstg-flood mb-legend-swstg-detail">
                      {{ legendStr.swStg.flood2 }}
                    </div>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters class="pb-1">
                <v-col>
                  <v-row no-gutters>
                    <div class="text-swstg-danger mb-legend-swstg-item">
                      {{ legendStr.swStg.danger1 }}
                    </div>
                  </v-row>
                  <v-row no-gutters>
                    <div class="text-swstg-danger mb-legend-swstg-detail">
                      {{ legendStr.swStg.danger2 }}
                    </div>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters class="pb-1">
                <v-col>
                  <v-row no-gutters>
                    <div class="text-swstg-start mb-legend-swstg-item">
                      {{ legendStr.swStg.start1 }}
                    </div>
                  </v-row>
                  <v-row no-gutters>
                    <div class="text-swstg-start mb-legend-swstg-detail">
                      {{ legendStr.swStg.start2 }}
                    </div>
                  </v-row>
                </v-col>
              </v-row>
            </span>
          </v-tooltip>
        </span>
        <!--上流側側での水位情報を基にして表示するベルアイコン表示しない -->
        <!-- <span
          class="pl-2"
          v-if="reqParam.itmkndCd === 4 && isDispStageWarningIcon"
        >
          <v-btn fab dark color="red darken-3" class="tm-mb-warning-icon">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on">notifications_active</v-icon>
              </template>
              <span
                >{{ stgMsg.upObsWarning1 }}<br />{{
                  stgMsg.upObsWarning2
                }}</span
              >
            </v-tooltip>
          </v-btn>
        </span> -->
        <v-spacer></v-spacer>
        <span
          class="tm-mb-info-card-info-area"
          v-if="reqParam.itmkndCd === 4 || reqParam.itmkndCd === 7"
        >
          <v-btn
            outlined
            x-small
            class="tm-mb-info-btn ml-2 tm-mb-rw-info-color"
            :rw-info-color="setRwInfoColor(tmRwInfo[0])"
            v-if="tmRwInfo.length > 0"
            @click="openRwInfo(tmRwInfo[0])"
          >
            <span class="tm-mb-info-btn-text" v-if="reqParam.itmkndCd === 4">{{
              text.rwStgInfo
            }}</span>
            <span class="tm-mb-info-btn-text" v-else>{{ text.rwDamInfo }}</span>
          </v-btn>
        </span>
        <span class="tm-mb-info-card-info-area">
          <v-btn
            outlined
            x-small
            class="tm-mb-info-btn tm-mb-info-color"
            :style="setInfoColor()"
            v-if="information.length > 0"
            @click="openInfo()"
          >
            <span>{{ setInfoText() }}</span>
          </v-btn>
        </span>
      </v-row>
      <v-btn
        v-show="!isFull && showExBtn"
        small
        icon
        color="white"
        @click="expansionWindow"
      >
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-btn
        v-show="isFull && showExBtn"
        small
        icon
        color="white"
        @click="reductionWindow"
      >
        <v-icon>fullscreen_exit</v-icon>
      </v-btn>
      <v-btn small icon color="white" @click="closeDlg">
        <v-icon>highlight_off</v-icon>
      </v-btn>
    </v-col>
    <v-col class="obs-dlg-frame">
      <tm-rain-frame
        @dispTmContentsSwitch="isDispConfig"
        v-if="reqParam.itmkndCd === 1"
      ></tm-rain-frame>
      <tm-bsn-frame
        @dispTmContentsSwitch="isDispConfig"
        v-if="reqParam.itmkndCd === 2"
      ></tm-bsn-frame>
      <tm-snow-frame
        @dispTmContentsSwitch="isDispConfig"
        v-if="reqParam.itmkndCd === 3"
      ></tm-snow-frame>
      <tm-stage-frame
        @dispWarningIcon="isDispWarnIcon"
        v-if="reqParam.itmkndCd === 4"
      ></tm-stage-frame>
      <tm-wtr-qual-frame
        @dispTmContentsSwitch="isDispConfig"
        v-if="reqParam.itmkndCd === 6"
      ></tm-wtr-qual-frame>
      <tm-dam-frame
        @dispTmContentsSwitch="isDispConfig"
        @changeFooter="changeTabIndex"
        v-if="reqParam.itmkndCd === 7"
      ></tm-dam-frame>
      <tm-coast-frame
        @dispTmContentsSwitch="isDispConfig"
        v-if="reqParam.itmkndCd === 12"
      ></tm-coast-frame>
      <tm-rd-bsn-frame
        @dispTmContentsSwitch="isDispConfig"
        v-if="reqParam.itmkndCd === 20"
      ></tm-rd-bsn-frame>
      <tm-cctv-frame v-if="reqParam.itmkndCd === 100"></tm-cctv-frame>
      <tm-scam-frame v-if="reqParam.itmkndCd === 200"></tm-scam-frame>
      <tm-sw-stage-frame
        @dispTmContentsSwitch="isDispConfig"
        @changeFooter="changeTabIndex"
        v-if="reqParam.itmkndCd === 300"
      ></tm-sw-stage-frame>
    </v-col>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]個別観測所画面
 * TmObs.vue
 * @author ILUKE
 */

import mixin from "./../../../lib/mixin.js";
import Util from "./../../../lib/util";
import TmRainFrame from "../../../components/mb/TmRainFrame.vue";
import TmSnowFrame from "../../../components/mb/TmSnowFrame.vue";
import TmStageFrame from "../../../components/mb/TmStageFrame.vue";
import TmWtrQualFrame from "../../../components/mb/TmWtrQualFrame.vue";
import TmDamFrame from "../../../components/mb/TmDamFrame.vue";
import TmCoastFrame from "../../../components/mb/TmCoastFrame.vue";
import TmBsnFrame from "../../../components/mb/TmBsnFrame.vue";
import TmRdBsnFrame from "../../../components/mb/TmRdBsnFrame.vue";
import TmCctvFrame from "../../../components/mb/TmCctvFrame.vue";
import TmScamFrame from "../../../components/mb/TmScamFrame.vue";
import TmSwStageFrame from "../../../components/mb/TmSwStageFrame.vue";
/**
 * 川の防災情報 観測所ダイアログ
 * TmObs.vue
 * @author LIS
 */
export default {
  name: "mb-tm-obs",
  mixins: [mixin],

  components: {
    TmRainFrame,
    TmSnowFrame,
    TmStageFrame,
    TmWtrQualFrame,
    TmDamFrame,
    TmCoastFrame,
    TmBsnFrame,
    TmRdBsnFrame,
    TmCctvFrame,
    TmScamFrame,
    TmSwStageFrame,
  },
  data() {
    return {
      tabIndex: 0,
      isDispStageWarningIcon: false,
      showExBtn: true,
      btnFontSize: 7,
      btnWidth: 30,
      text: {
        info: "お知らせ",
        rwStgInfo: "洪水予報等",
        rwDamInfo: "ダム放流通知",
      },
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    };
  },
  created() {
    const urlTime = this.$route.query["tmtime"];
    if (urlTime != undefined) {
      let setTime = new Date();
      if (Util.formatDate(urlTime) !== "Invalid Date") {
        setTime = Util.toDate(urlTime);
      }
      // 5分単位に丸める
      setTime.setMinutes(Math.floor(setTime.getMinutes() / 5) * 5);
      this.$store.commit("app/setTime", setTime);
    }
  },
  mounted: function() {
    this.$log.debug("[TmObs] mounted()");
    this.initObs();
    if (!this.reqParam.itmkndCd) {
      this.routerMbHome();
    }
    this.setFull(false);
    if (this.winWidth > this.winHeight) {
      this.showExBtn = false;
      this.setFull(true);
    }
    window.addEventListener("resize", this.handleResize);
    // ブラウザバック時にリロードイベントを登録
    window.addEventListener("popstate", this.reload, false);
  },
  /** 破棄部 */
  destroyed() {
    // リロードイベントを削除
    window.removeEventListener("popstate", this.reload, false);
  },
  watch: {
    isFull(b) {
      if (b) {
        /** 画面拡大 */
        const element = document.getElementById("tm-obs-dialog");
        element.className = "com-mb-dialog large v-card v-sheet theme--light tm-mb-no-shadow";
        this.isFull = true;
      } else {
        /** 画面縮小 */
        const element = document.getElementById("tm-obs-dialog");
        element.className = "com-mb-dialog normal v-card v-sheet theme--light tm-mb-no-shadow";
        this.isFull = false;
      }
    },
    information() {
      // お知らせが1件以上ある場合、色とテキストを判定
      if (this.information.length > 0) {
        this.$store.dispatch("info/getInfoTitleColor", {
          information: this.information,
        });
      }
    },
  },
  methods: {
    /** 初期化処理 */
    initObs() {
      /** URLからの遷移はGETから選択中テレメータ情報パラメータセット */
      if (!this.selectedTmParamCheck()) {
        /** 選択中テレメータ情報パラメータセット */
        this.setUrlSelectedTmParam();
      }

      /** 表示コンテンツのセット */
      this.$log.debug("[TmObs] setContent-TmObs");
      this.$store.commit("app/setContent", "TmObs");
    },
    /** 画面拡大 */
    expansionWindow() {
      this.setFull(true);
    },
    /** 画面縮小 */
    reductionWindow() {
      this.setFull(false);
    },
    /** 画面を閉じる */
    closeDlg() {
      // お知らせ・河川予警報ダイアログ非表示
      this.$store.commit("map/hideInfoRw");
      this.$store.commit("app/setContent", "");
      this.routerPush("/mb");
    },
    changeTabIndex(tabIndex) {
      this.tabIndex = tabIndex;
    },
    isDispConfig(flg) {
      this.isDispcContentsSwitch = flg;
    },
    isDispWarnIcon(flg) {
      this.isDispStageWarningIcon = flg;
    },
    /** 選択中テレメータ情報パラメータチェック */
    selectedTmParamCheck() {
      if (
        this.$store.state.Telemeter.selectedTmParam.ofcCd &&
        this.$store.state.Telemeter.selectedTmParam.itmkndCd &&
        (this.$store.state.Telemeter.selectedTmParam.obsCd ||
          this.$store.state.Telemeter.selectedTmParam.cctvCd ||
          this.$store.state.Telemeter.selectedTmParam.scamId ||
          this.$store.state.Telemeter.selectedTmParam.ownCd ||
          this.$store.state.Telemeter.selectedTmParam.sysCamId ||
          this.$store.state.Telemeter.selectedTmParam.sysId)
      ) {
        return true;
      } else {
        return false;
      }
    },
    /** GETから選択中テレメータ情報パラメータセット */
    setUrlSelectedTmParam() {
      // url解析
      const ofcCd = isNaN(this.$route.query["ofcCd"])
        ? null
        : Number(this.$route.query["ofcCd"]);
      const itmkndCd = isNaN(this.$route.query["itmkndCd"])
        ? null
        : Number(this.$route.query["itmkndCd"]);
      const obsCd = isNaN(this.$route.query["obsCd"])
        ? null
        : Number(this.$route.query["obsCd"]);
      const cctvCd = isNaN(this.$route.query["cctvCd"])
        ? null
        : Number(this.$route.query["cctvCd"]);
      const scamId = isNaN(this.$route.query["scamId"])
        ? null
        : Number(this.$route.query["scamId"]);
      const ownCd = isNaN(this.$route.query["ownCd"])
        ? null
        : Number(this.$route.query["ownCd"]);
      const sysCamId = isNaN(this.$route.query["sysCamId"])
        ? null
        : Number(this.$route.query["sysCamId"]);
      const sysId = isNaN(this.$route.query["sysId"])
        ? null
        : Number(this.$route.query["sysId"]);

      if (itmkndCd == 300) {
        //危機管理型水位計情報を設定
        this.$store.commit("Swin/setSelectedSwParam", {
          swofcCd: ofcCd,
          itmkndCd: itmkndCd,
          swobsCd: obsCd,
          swcctvCd: cctvCd,
        });
      } else {
        // 選択中テレメータ情報を設定
        this.$store.commit("Telemeter/setSelectedTmParam", {
          ofcCd: ofcCd,
          itmkndCd: itmkndCd,
          obsCd: obsCd,
          cctvCd: cctvCd,
          scamId: scamId,
          ownCd: ownCd,
          sysCamId: sysCamId,
          sysId: sysId,
        });
      }
    },
    setFull(b) {
      this.$store.commit("Telemeter/setMbTmObsIsExpansion", b);
    },
    /** お知らせ情報表示 */
    openInfo() {
      if (this.$store.state.map.showInformation === false) {
        if (this.information.length === 1) {
          // 1件のみの場合は直接遷移する
          this.linkInfoUrl(this.information[0].infoManageCode);
        } else {
          this.$store.commit("map/showInformation");
        }
      } else if (!this.isFull) {
        this.$store.commit("map/hideInfoRw");
      }
      this.tmObsSetReducation();
    },
    /** お知らせクリック時の処理 */
    linkInfoUrl(infoManageCd) {
      this.routerPushMbInfoDetail("/mb/info/detail", infoManageCd);
      this.$store.commit("map/hideInfoRw");
    },
    /** 河川予警報情報表示 */
    openRwInfo(tmRwInfo) {
      if (this.$store.state.map.showRiverWarnInfo === false) {
        if (this.tmRwInfoLength === 1) {
          // 1件のみの場合は直接遷移する
          this.linkRwUrl(tmRwInfo.code, tmRwInfo.type);
        } else {
          this.$store.dispatch("map/getObsRiverWarnInfo", {
            ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
            itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
            obsCd: this.$store.state.Telemeter.selectedTmParam.obsCd,
            isFldCtl: this.$store.getters["app/isFldCtl"],
            appTime: this.$store.state.app.appTimeRound,
          });
        }
      } else {
        this.$store.commit("map/hideInfoRw");
      }
      this.tmObsSetReducation();
    },
    /** 河川予警報クリック時の処理 */
    linkRwUrl(code, type) {
      switch (type) {
        case "fldfr":
          type = 10;
          break;
        case "evstg":
          type = 11;
          break;
        case "fldctl":
          type = 20;
          break;
        case "damdsch":
          type = 30;
          break;
        default:
          return;
      }
      // ストアに予警報ID、予警報タイプを設定
      this.$store.commit("RiverWarn/setSelectedWarnReq", {
        cd: code,
        type: type,
      });
      // 河川予警報画面に遷移
      if (this.$store.state.app.mode == "pc") {
        this.routerPushRw("/pc/rw");
      } else {
        this.routerPushRw("/mb/rwdetail");
      }

      this.$store.commit("map/hideInfoRw");
    },
    /** [MB]個別観測所画面を縮小する */
    tmObsSetReducation() {
      this.$store.commit("Telemeter/setMbTmObsIsExpansion", false);
    },
    /** お知らせボタン 文字 */
    setInfoText() {
      if (this.titleSummaryCode.pcText !== undefined) {
        return this.titleSummaryCode.mbText;
      } else {
        return this.text.info;
      }
    },
    /** お知らせボタン 着色 */
    setInfoColor() {
      if (this.infoConfig.titleSummaryCode !== undefined) {
        if (
          this.titleSummaryCode.backGroundColor !== undefined &&
          this.titleSummaryCode.textColor !== undefined
        ) {
          return {
            backgroundColor: this.titleSummaryCode.backGroundColor,
            color: this.titleSummaryCode.textColor
          };
        } else {
          // 設定ファイルにないsummaryCodeの場合、その他(summaryCode=5で着色)
          const code = 5;
          return {
            backgroundColor: this.infoConfig.titleSummaryCode[code].backGroundColor,
            color: this.infoConfig.titleSummaryCode[code].textColor
          }
        }
      } else {
        // 設定ファイルにtitleSummaryCodeが無い場合
        return {
          backgroundColor: "#ffffff",
          color: "#000000"
        }
      }
    },
    /** 河川予警報ボタン 着色 */
    setRwInfoColor(info) {
      // 洪水予報か水位周知河川情報
      if (info.type === "evstg" || info.type === "fldfr") {
        if (info.lvl === 90) {
          return "occurrence";
        } else if (info.lvl === 80) {
          return "danger";
        } else if (info.lvl === 60) {
          return "refuge";
        } else if (info.lvl === 30) {
          return "warn";
        }
      }
      // ダム放流通知
      else if (info.type === "damdsch") {
        if (info.lvl === 70) {
          return "disasteroperating";
        } else if (info.lvl === 50) {
          return "riserving";
        }
      }
      // 水防警報
      else if (info.type === "fldctl") {
        if (info.lvl === 40) {
          return "dispatch";
        } else if (info.lvl === 20) {
          return "preparation";
        } else if (info.lvl === 10) {
          return "standby";
        }
      }
      return "other";
    },
    handleResize() {
      this.winWidth = window.innerWidth;
      this.winHeight = window.innerHeight;
      if (this.winWidth > this.winHeight) {
        this.expansionWindow();
        this.showExBtn = false;
      } else {
        this.reductionWindow();
        this.showExBtn = true;
      }
    },
    /** リロード */
    reload() {
      /** 選択中テレメータ情報パラメータセット */
      this.setUrlSelectedTmParam();

      /** 表示コンテンツのセット */
      this.$log.debug("[TmObs] setContent-TmObs");
      this.$store.commit("app/setContent", "TmObs");
    },
  },
  computed: {
    /** リクエストパラメータ */
    reqParam: {
      get() {
        if (
          this.$store.state.Telemeter.selectedTmParam.itmkndCd &&
          Number(this.$route.query["itmkndCd"]) !== 300
        ) {
          // 危機管理水位が選択されていない場合
          return this.$store.state.Telemeter.selectedTmParam;
        } else {
          return this.$store.state.Swin.selectedSwParam;
        }
      },
    },
    /** 対象日時 */
    appTime: {
      get() {
        return this.$store.state.app.appTime;
      },
    },
    /**
     * お知らせ情報全件取得
     */
    information: {
      get() {
        return this.$store.state.map.information;
      },
    },
    /**
     * 河川予警報情報の中で緊急度が一番高い１レコードのみ取得
     */
    tmRwInfo: {
      get() {
        return this.$store.state.map.tmRwInfo;
      },
    },
    /**
     * 河川予警報情報の数を取得
     */
    tmRwInfoLength: {
      get() {
        return this.$store.state.map.tmRwInfoLength;
      },
    },
    isFull: {
      get() {
        return this.$store.state.Telemeter.mbTmObsIsExpansion;
      },
      set() {
        // warning出力対策用のsetter
      },
    },
    /** 凡例共通文言 */
    legendStr: {
      get() {
        return this.$store.state.app.config.messageConfig.legendMsg;
      },
    },
    /**
     * 水位表示メッセージ
     */
    stgMsg: {
      get() {
        return this.$store.state.app.config.messageConfig.stg;
      },
    },
    /** お知らせのタイトルと色 */
    titleSummaryCode: {
      get() {
        return this.$store.state.info.titleSummaryCode;
      },
    },
    /** お知らせ設定情報 */
    infoConfig: {
      get() {
        return this.$store.state.info.informationConfig;
      },
    },
  },
  beforeDestroy: function() {
    this.setFull(false);
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../../scss/_media_query.scss";
@import "./../../../scss/color.scss";

@include landscape {
  .normal {
    width: 50%;
    max-width: 400px;
    height: 60%;
    top: 84px;
  }
  .large {
    width: 50%;
    max-width: 400px;
    height: calc(100% - 84px);
    top: 84px;
  }
}
@include portrait {
  .normal {
    width: calc(100% - 16px);
    max-width: 400px;
    height: 50%;
    bottom: 4px;
  }
  .large {
    width: calc(100% - 16px);
    max-width: 400px;
    height: calc(100% - 84px);
    bottom: 4px;
  }
}

#tm-obs-dialog {
  background-color: $color-card-back;
  position: absolute;
  z-index: 3070;
  right: 4px;

  .obs-header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 35px;
    padding: 0;
    background-color: $color-header-back;
    color: $color-header-text;
    .obs-kind {
      margin: 0;
      padding-left: 12px;
      align-items: center;
      .obs-title {
        font-size: 0.7rem;
      }
      /* アラートアイコン */
      .tm-mb-warning-icon {
        height: 24px;
        width: 24px;
      }
      .tm-mb-info-btn {
        margin-bottom: 3px;
        .tm-mb-info-btn-text {
          font-size: 0.7rem;
        }
      }
      /* 河川予警報アイコン 色分け */
      .tm-mb-rw-info-color {
        // 氾濫開始水位超過（氾濫発生情報）
        &[rw-info-color="occurrence"] {
          background-color: $color-90;
          color: $color-90-text;
        }

        // 氾濫危険水位超過（氾濫危険情報）
        &[rw-info-color="danger"] {
          background-color: $color-80;
          color: $color-80-text;
        }

        // 避難判断水位超過（氾濫警戒情報）
        &[rw-info-color="refuge"] {
          background-color: $color-60;
          color: $color-60-text;
        }

        // 氾濫注意水位超過（氾濫注意情報）
        &[rw-info-color="warn"] {
          background-color: $color-30;
          color: $color-30-text;
        }

        // 異常洪水時防災操作等実施中
        &[rw-info-color="disasteroperating"] {
          background-color: $color-70;
          color: $color-70-text;
        }

        // 洪水貯留操作実施中
        &[rw-info-color="riserving"] {
          background-color: $color-50;
          color: $color-50-text;
        }

        // 出動
        &[rw-info-color="dispatch"] {
          background-color: $color-40;
          color: $color-40-text;
        }

        // 準備
        &[rw-info-color="preparation"] {
          background-color: $color-20;
          color: $color-20-text;
        }

        // 待機
        &[rw-info-color="standby"] {
          background-color: $color-10;
          color: $color-10-text;
        }

        // その他
        &[rw-info-color="other"] {
          background-color: $color-rw-0;
        }
      }
    }
  }
  .obs-dlg-frame {
    position: relative;
    height: calc(100% - 35px);
    overflow: auto;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    & > :not(:first-child) {
      margin-top: 12px;
    }
  }
  /* お知らせボタン */
      .tm-mb-info-color {
        // マージン
        margin-left: 5px;
      }
}
</style>
